<template>
  <div class="w-full h-full flex items-center justify-center p-8">
    <!-- Auth 右欄固定深色底；SSR 與瀏覽器均直接顯示產品品牌。 -->
    <img
      :src="XSENAL_BRAND.fullDark"
      alt="Xsenal"
      class="w-full max-w-[240px] h-auto"
    />
  </div>
</template>

<script setup lang="ts">
import { XSENAL_BRAND } from '~/constants/brand';
</script>
